import { render, staticRenderFns } from "./CreateBulkShipmentDialog.vue?vue&type=template&id=0b523698&scoped=true&"
import script from "./CreateBulkShipmentDialog.vue?vue&type=script&lang=ts&"
export * from "./CreateBulkShipmentDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CreateBulkShipmentDialog.vue?vue&type=style&index=0&id=0b523698&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b523698",
  null
  
)

export default component.exports